export const CANCEL_SUBSCRIPTION = 'SUBSCRIPTION/CANCEL_SUBSCRIPTION';
export const FETCH_USER_SUBSCRIPTIONS = 'SUBSCRIPTION/FETCH_USER_SUBSCRIPTIONS';
export const FETCH_USER_SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTION/FETCH_USER_SUBSCRIPTIONS_REQUEST';
export const FETCH_USER_SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTION/FETCH_USER_SUBSCRIPTIONS_SUCCESS';
export const FETCH_USER_SUBSCRIPTIONS_ERROR = 'SUBSCRIPTION/FETCH_USER_SUBSCRIPTIONS_ERROR';
export const RESET_SUBSCRIPTIONS = 'SUBSCRIPTION/RESET_SUBSCRIPTIONS';
export const SEND_SUBSCRIPTION_FEEDBACK = 'SUBSCRIPTION/SEND_SUBSCRIPTION_FEEDBACK';
export const UPDATE_SUBSCRIPTION = 'SUBSCRIPTION/UPDATE_SUBSCRIPTION';
export const SET_CANCELLATION_CANDIDATE = 'SUBSCRIPTION/SET_CANCELLATION_CANDIDATE';
export const FETCH_DISCOUNT_SUBSCRIPTION = 'SUBSCRIPTION/FETCH_DISCOUNT_SUBSCRIPTION';
export const FETCH_DISCOUNT_SUBSCRIPTION_REQUEST = 'SUBSCRIPTION/FETCH_DISCOUNT_SUBSCRIPTION_REQUEST';
export const FETCH_DISCOUNT_SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION/FETCH_DISCOUNT_SUBSCRIPTION_SUCCESS';
export const FETCH_DISCOUNT_SUBSCRIPTION_ERROR = 'SUBSCRIPTION/FETCH_DISCOUNT_SUBSCRIPTION_ERROR';
export const RESTORE_SUBSCRIPTION = 'SUBSCRIPTION/RESTORE_SUBSCRIPTION';
export const SET_CANCEL_REASON = 'SUBSCRIPTION/SET_CANCEL_REASON';
export const PAUSE_SUBSCRIPTION = 'SUBSCRIPTION/PAUSE_SUBSCRIPTION';
export const RESUME_SUBSCRIPTION = 'SUBSCRIPTION/RESUME_SUBSCRIPTION';
export const SET_REMINDER = 'SUBSCRIPTION/SET_REMINDER';
export const CANCEL_SUBSCRIPTION_WITH_OFFER = 'SUBSCRIPTION/CANCEL_SUBSCRIPTION_WITH_OFFER';
export const RESET_SUBSCRIPTION = 'SUBSCRIPTION/RESET_SUBSCRIPTION';
